import React from 'react'
import Popup from 'shared/components/Popup'

export default function IconFrame({
  icon,
  iconSize,
  frameSize,
  color,
  enableTooltip,
  tooltipText,
  tooltipPosition,
}) {
  if (!enableTooltip) {
    return (
      <div
        className={`relative flex items-center justify-center ${color}`}
        style={{ width: frameSize, height: frameSize }}
      >
        <i className={`far ${icon}`} style={{ fontSize: iconSize }} />
      </div>
    )
  }

  return (
    <span className="inline-flex">
      <div
        className={`relative flex items-center justify-center ${color}`}
        style={{ width: frameSize, height: frameSize }}
      >
        <Popup
          basic
          content={tooltipText}
          position={tooltipPosition}
          size="mini"
          trigger={<i className={`far ${icon}`} style={{ fontSize: iconSize }} />}
        />
      </div>
    </span>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/shared/components/IconFrame/index.js